













export default {
    "name": "StateTranslationNeeded"
    "props": {
        "context": {
            "type": Object
            "required": true
        }
    }
    "methods":
        "save_answer": ()->
            @$emit("state:update_data", @context.data)
}
